import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import useInitPurchase from '@hooks/useInitPurchase';
import FormLayout from '@/containers/formLayout';
import Address from '@/containers/address';
import ChoosePersonalData from '@/containers/choosePersonalData';
import Payment from '@/containers/payment';
import { SEGMENT, BUBBLE_TEXTS } from '@/constants/constant';
import { FORM_ID, NEXT_STEPS } from '@/constants/pages/baf';
import getDeviceKindDependsOnViewPort from '@gcloud-npm/utils.common.get-device-kind-depends-on-viewport';
import { actions } from '@/reducers/form-baf-reducer';
import { actions as retargetingActions } from '@/reducers/retargeting-reducer';
import { INSTALLATION_ADDRESS } from '@/constants/installationAddress';

const BafNoClientForm = () => {
  const dispatch = useDispatch();
  const initialShoppingCart = useSelector(
    (state) => state.formBaf.initialShoppingCart
  );
  const shoppingCart = useSelector((state) => state.formBaf.shoppingCart);
  const loadingShoppingCart = useSelector(
    (state) => state.formBaf.loadingShoppingCart
  );
  const checkout = useSelector((state) => state.formBaf.checkout);
  const [showErrorBubble, setShowErrorBubble] = useState(false);

  const { unregister, getValues, handleSubmit, resetField, control, setValue } =
    useForm({
      mode: 'onTouched',
    });

  const onSubmit = async (formData) => {
    setShowErrorBubble(false);
    const deviceKind = getDeviceKindDependsOnViewPort();
    dispatch(actions.checkout({ formData, deviceKind }));
  };
  const onError = (formErrors) => {
    if (Object.keys(formErrors).length > 1) {
      setShowErrorBubble(true);
      if ('scrollTo' in window && typeof window.scrollTo === 'function') {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant',
        });
      }
    } else if (Object.keys(formErrors).length === 1) {
      setShowErrorBubble(false);
      const scrollElement = document.getElementById(Object.keys(formErrors)[0]);
      if (scrollElement) {
        scrollElement.scrollIntoView({ behavior: 'instant' });
      }
    }
  };

  const { setSegment, setFirstZone, initPurchase } = actions;
  useInitPurchase({
    segment: SEGMENT.autonomos,
    initPurchase,
    setSegment,
    setZone: setFirstZone,
    loaded: !!shoppingCart,
  });

  useEffect(() => {
    if (
      initialShoppingCart !== null &&
      window.grecaptcha &&
      window.grecaptcha.enterprise
    ) {
      window.grecaptcha.enterprise.ready(() => {
        dispatch(
          retargetingActions.sendRetargeting({
            ...initialShoppingCart,
            campaignId: 'ret-baf-cart',
          })
        );
      });
    }
  }, [initialShoppingCart, dispatch]);

  return (
    <>
      <Head>
        <script
          async
          src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID}`}
        />
      </Head>
      <FormLayout
        pageId={FORM_ID.GP}
        onSubmit={handleSubmit(onSubmit, onError)}
        control={control}
        showErrorBubble={showErrorBubble}
        textBubble={BUBBLE_TEXTS.BUBBLE_ERROR_TEXT}
        loaded={!!shoppingCart}
        shoppingCart={shoppingCart}
        loadingShoppingCart={loadingShoppingCart}
        loadingButtonShoppingCart={checkout}
        nextStepsText={NEXT_STEPS}
        urlLoginCardRedirect={shoppingCart ? document.location.href : ''}
      >
        <ChoosePersonalData control={control} showRadioInput />
        <Address
          unregister={unregister}
          control={control}
          getValues={getValues}
          resetField={resetField}
          componentName={INSTALLATION_ADDRESS.ID}
          formStructure={INSTALLATION_ADDRESS}
          setInfo={actions.setInfo}
          setValue={setValue}
        />
        <Payment loaded={!!shoppingCart} control={control} />
      </FormLayout>
    </>
  );
};
export default BafNoClientForm;
